import { takeLatest, put, call } from "redux-saga/effects";
import { createAction } from "@reduxjs/toolkit";
import { getTickets, getTicketById, updateTicketStatus } from "../../../services/adminSupportService";
import { setLoading, setTickets, setSelectedTicket, setError, clearError, updateTicketStatusLocal } from "../../Reducers/Admin/adminSupportReducer";

export const GetTicketsAction = createAction("GET_TICKETS");
export const GetTicketByIdAction = createAction("GET_TICKET_BY_ID");
export const UpdateTicketStatusAction = createAction("UPDATE_TICKET_STATUS");

function* getTicketsSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    const resp = yield call(getTickets, action.payload);
    if (resp?.ok) {
      yield put(setTickets(resp.data));
    } else {
      yield put(setError(resp?.data?.message || resp?.problem || "Failed to fetch tickets"));
    }
  } catch (e) {
    yield put(setError(e?.message || "Failed to fetch tickets"));
  } finally {
    yield put(setLoading(false));
  }
}

function* getTicketByIdSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    const resp = yield call(getTicketById, action.payload);
    if (resp?.ok) {
      yield put(setSelectedTicket(resp.data?.data));
    } else {
      yield put(setError(resp?.data?.message || resp?.problem || "Failed to fetch ticket"));
    }
  } catch (e) {
    yield put(setError(e?.message || "Failed to fetch ticket"));
  } finally {
    yield put(setLoading(false));
  }
}

function* updateTicketStatusSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    const resp = yield call(updateTicketStatus, action.payload);
    if (resp?.ok) {
      const { ticketId, status } = action.payload;
      yield put(updateTicketStatusLocal({ ticketId, status }));
    } else {
      yield put(setError(resp?.data?.message || resp?.problem || "Failed to update status"));
    }
  } catch (e) {
    yield put(setError(e?.message || "Failed to update status"));
  } finally {
    yield put(setLoading(false));
  }
}

export function* watchSupportTickets() {
  yield takeLatest(GetTicketsAction.type, getTicketsSaga);
  yield takeLatest(GetTicketByIdAction.type, getTicketByIdSaga);
  yield takeLatest(UpdateTicketStatusAction.type, updateTicketStatusSaga);
}


